import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import moment from "moment";
import {Checkbox} from "antd";

import {api} from "../../../../services";
import DetailItem from "./DetailItem";
import {WarningIcon} from "../../../../common/icons";
import AirButton from "../../../../common/components/AirButton";
import PositionsDetail from "./PositionsDetail";

import './TripItem.css'
import NoteInput from "./NoteInput";

@inject('translationsStore', 'tripsStore', 'commonStore')
@observer
export default class TripItemMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crashEvents: 0,
      overRpmsCount: 0
    }
  }

  componentDidMount() {
    this.setCrashEvents();
    this.setOverRpms();
  }

  setCrashEvents = () => {
    const {
      trip: { startAt, endAt, car }
    } = this.props;
    const startTime = startAt ? startAt : new Date().toISOString(),
      endTime = endAt ? endAt : new Date().toISOString();
    let crashEvents;
    api('getCarCrashEvents', car.plate, startTime, endTime)
      .then(response => {
        crashEvents = response.count;
      })
      .catch(() => {
        crashEvents = 0;
      })
      .finally(() => {
        this.setState({ crashEvents });
      });
  };

  setOverRpms = () => {
    const {
      trip: { startAt, endAt, car }
    } = this.props;
    api('getRpm', this.props.trip.carId, moment(startAt).format('YYYY-MM-DD'), moment(endAt ? endAt : startAt).format('YYYY-MM-DD'))
      .then(rawOverRpms => {
        return rawOverRpms;
      })
      .catch(() => {})
      .then(rawOverRpms => {
        const overRpmsCount = rawOverRpms.rpms.filter(rpm => rpm.startDateTime >= startAt && rpm.endDateTime <= endAt);
        this.setState({
          overRpmsCount: overRpmsCount
        });
      });
  }

  getAlarmsCount = () => {
    const {trip} = this.props;
    return (
      Number(trip.accelerations) +
      Number(trip.brakes) +
      Number(trip.leftTurns) +
      Number(trip.rightTurns) +
      Number(trip.overDrives) +
      Number(this.state.overRpmsCount) +
      Number(this.state.crashEvents)
    );
  }

  handleNoteChange = (note) => {
    const trip = {...this.props.trip, note};
    this.props.tripsStore.updateTrip(trip)
  }

  render() {
    const {trip, translationsStore, tripsStore, commonStore} = this.props;

    return (
      <div className={`TripItemMap TripItem${tripsStore.mapViewSelectedTrip && tripsStore.mapViewSelectedTrip.id === trip.id ? ' selected' : ''}`} onClick={() => tripsStore.selectSingleTrip(trip)}>
        <div className="TripTitle">
          <div className="TripDate">
            {`${moment(trip.startAt).utcOffset(0).format("dddd, D MMMM (HH:mm")}${trip.endAt ? ` - ${moment(trip.endAt).utcOffset(0).format("HH:mm")}` : ''})`}
          </div>
          {this.getAlarmsCount() > 0 && <div style={{color: '#ff5d58', display: 'flex'}}><WarningIcon style={{fontSize: 18, marginRight: 5}} /></div>}
        </div>
        <PositionsDetail trip={trip} />
        <div className="TripDetails">
          <DetailItem label={translationsStore.translate('tripsList.detail.time')} value={moment.duration(trip.duration || 0, 'seconds').format('h:mm:ss [h]', { trim: false })} />
          <DetailItem label={translationsStore.translate('tripsList.detail.distance')} value={`${trip.distance} km`} />
          <DetailItem label={translationsStore.translate('tripsList.detail.vehicle')} value={trip.car.plate} />
        </div>
        <div className="NoteInputContainer">
          <NoteInput value={trip.note} onChange={this.handleNoteChange} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripItem/TripItemMap.js